import { Injectable } from '@angular/core';
import { Simulate, FoamingObj, ProcessData, CloneMaterial, CloneResult, Recipe } from '@usimweb/core/models';
import { ApiService } from '@usimweb/core/services';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CloneService {
  private newUuid: string = '';

  private simulate = {} as Simulate;
  private processData = {} as ProcessData;

  private foamId: number = 0;
  private recipeId: number = 0;
  private materialTemperature: number = 0;

  public cloningCallBack = new BehaviorSubject<CloneResult>({} as CloneResult);

  constructor(private apiService: ApiService) {}

  public getSimulate(): Simulate {
    return this.simulate;
  }

  public getMaterialData(): CloneMaterial {
    return {
      material: this.foamId,
      recipe: this.recipeId,
      temperature: this.materialTemperature,
    };
  }

  public getProcessData(): ProcessData {
    return this.processData;
  }

  public clone(project_uuid: string, version_uuid: string) {
    this.apiService.addFoaming(project_uuid, version_uuid).subscribe((result) => {
      const uuid = result.uuid || '';

      this.newUuid = uuid;
      this.getVersionData(version_uuid);
    });
  }

  public getVersionData(uuid: string): void {
    const subscription = this.apiService.getFoamingResult(uuid, 'filling').subscribe((result) => {
      subscription.unsubscribe();

      const foaming = result['foaming'][0] as FoamingObj;
      const recipe = result['recipe'][0] as Recipe;

      const simulate: Simulate = {
        name: '',
        simulationTime: foaming.simulationTime,
        cpus: foaming.nCpus,
        outPutTime: foaming.outputTime,
        appType: foaming.appType || '',
        credits: foaming.credits || 0,
      };

      this.simulate = simulate;

      this.processData.injectionRate = foaming.injectionRate;
      this.processData.targetDensity = foaming.targetDensity;

      this.foamId = recipe.foam || 0;
      this.recipeId = recipe.id || 0;
      this.materialTemperature = foaming.materialTemperature;

      this.cloningCallBack.next({ cloned: true, uuid: this.newUuid });
    });
  }
}
